<app-tools-catalogue-menu
  [breadcrumbLinks]="breadcrumbLinks"
></app-tools-catalogue-menu>
<div class="container m-t-alt mb-6">
  <div class="columns is-multiline">
    <div class="column is-12">
      <app-tools-catalogue-submenu
        [isMetricSubNav]="true"
      ></app-tools-catalogue-submenu>
    </div>
  </div>
  <div class="columns">
    <div class="column is-4-tablet is-3-widescreen">
      <app-list-filter
        [filterGroups]="filterGroups"
        [listPath]="currentPath"
        [selectedOptionIds]="queryParams"
        [resourceSlug]="resourceSlug"
        (selectedOptionsLoaded)="selectedOptions = $event"
        (selectedOptionsChanged)="filter($event)"
      ></app-list-filter>
      <div class="card has-background-white">
        <h3
          class="is-size-6 is-sans mb-4 is-uppercase is-bold has-text-warning"
        >
          <i class="fas fa-object-group"></i>
          SUBMIT A METRIC
        </h3>
        <p class="content is-small">
          If you have a tool that you think should be featured in the Catalogue
          of AI Tools & Metrics, we would love to hear from you!
        </p>
        <a
          routerLink="/catalogue/tools/submit"
          class="button is-warning has-text-weight-bold"
          >Submit</a
        >
      </div>
    </div>

    <div class="column">
      <!-- Main container -->

      <nav class="level">
        <!-- Left side -->
        <div class="level-left">
          <h1 class="level-item my-0 is-size-5 is-serif is-bold">
            List of technical metrics
            <span class="ml-2" *ngIf="metrics">({{ metrics.total }})</span>
          </h1>
        </div>
        <div class="level-right">
          <div class="level-item my-0 content is-small is-bold">
            <a
              [routerLink]="currentPath"
              [queryParams]="{ toXLS: 'true' }"
              queryParamsHandling="merge"
              class="ghost has-text-link has-tooltip-primary has-tooltip-arrow is-flex is-align-items-center is-justify-content-center mr-4"
              data-tooltip="Download  list in .csv format"
              [ngClass]="{ 'is-loading': loadingExport }"
              ><i class="icon icon-Download1 is-size-2"></i
            ></a>
          </div>
          <div class="level-item my-0 content is-small is-bold">
            <div class="control full-width">
              <div class="select is-small select--sort">
                <select (change)="onSort($event)" #sortSelect>
                  <option class="sort-ascending" value="">
                    &#9660; Relevance
                  </option>
                  <option class="sort-ascending" value="nameAsc">
                    &#9650; Name
                  </option>
                  <option class="sort-descending" value="nameDesc">
                    &#9660; Name
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div class="columns">
        <div class="column content is-small">
          This page includes technical metrics and methodologies for measuring
          and evaluating AI trustworthiness and AI risks. These metrics are
          often represented through mathematical formulas that assess the
          technical requirements for achieving trustworthy AI in a particular
          context. They can help to ensure that a system is fair, accurate,
          explainable, transparent, robust, safe, or secure.
        </div>
      </div>
      <ng-container *ngIf="selectedOptions.length">
        <div class="field is-grouped is-grouped-multiline mb-0 pb-0">
          <div class="control" *ngFor="let option of selectedOptions">
            <div class="tags has-addons">
              <span class="tag is-primary">
                {{ option.filterTitle }}
              </span>
              <span class="tag is-white-bis">
                {{ option.label | stripHtml }} </span
              ><span
                class="tag is-delete is-white-bis pointer"
                (click)="removeSelectedOption(option)"
                (keydown)="removeSelectedOption(option)"
                tabindex="0"
              ></span>
            </div>
          </div>
          <div class="control">
            <a
              data-tooltip="Clear all the selected filters"
              class="tag is-white has-tooltip-primary has-tooltip-arrow has-text-primary"
              [routerLink]="currentPath"
            >
              <span>Clear filters</span>
            </a>
          </div>
        </div>
      </ng-container>

      <hr class="mb-6 bg-white-bis mt-0" />

      <ng-container *ngIf="metrics">
        <ng-container *ngIf="metrics.data.length === 0">
          <h4 class="mb-0">There are no results for your search.</h4>
          <p class="mt-3">Try to remove some filters to expand your search.</p>
        </ng-container>
        <ng-container *ngFor="let metric of metrics.data">
          <app-metric-card [metric]="metric"></app-metric-card>
        </ng-container>

        <app-pagination
          [paginator]="metrics"
          (pageChange)="goToPage($event)"
        ></app-pagination>
      </ng-container>

      <app-catalogue-loader *ngIf="loading"></app-catalogue-loader>
    </div>
  </div>
</div>

<app-tools-catalogue-disclaimer></app-tools-catalogue-disclaimer>
